// extracted by mini-css-extract-plugin
export var block = "CommonLayout-module--block--3ac79";
export var container = "CommonLayout-module--container--199a1";
export var description = "CommonLayout-module--description--752ec";
export var fadeInAnimation = "CommonLayout-module--fadeInAnimation--21048";
export var fullBlock = "CommonLayout-module--fullBlock--9f667";
export var layout = "CommonLayout-module--layout--da176";
export var section = "CommonLayout-module--section--95bd5";
export var sections = "CommonLayout-module--sections--4827f";
export var title = "CommonLayout-module--title--60af3";
export var visualConcept = "CommonLayout-module--visualConcept--d9713";